import React from 'react';
import { Box } from '@sparrowengg/twigs-react';
import Navbar from 'commons/components/navbar';
import EditLocalDevApp from 'features/apps/edit-local-dev-app/components';

const EditLocalDevAppPage = () => {
  return (
    <Box css={{ height: '100vh', width: '100vw', overflow: 'hidden' }}>
      <Navbar showPreviousBtn />
      <EditLocalDevApp />
    </Box>
  );
};

export default EditLocalDevAppPage;
